import { render, staticRenderFns } from "./businessInfo.vue?vue&type=template&id=149e214a"
import script from "./businessInfo.vue?vue&type=script&lang=js"
export * from "./businessInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports